
export enum ControlZoneEnum {
	left = 0,
	middle = 1,
	right=2,
}